module.exports = __webpack_public_path__ + "static/logo-eau-new-4fd168074bdefcdec07378e1e624bc1c.png";